import React from "react";
// --- Import Img
import ThankyouImg from "../../../assets/images/refund_thankyou_img.png";

import "./RefundThankyouPage.sass";

function RefundThankyouPage() {
  return (
    <>
      <div className="thankyou-wrapper">
        <h3 className="thankyou__title">Thank you!</h3>
        <img className="thankyou__img" src={ThankyouImg} alt="" />
        <p className="thankyou__text">
          We have received your request! <br /> Please check your inbox for a
          confirmation email from us.
        </p>
      </div>
    </>
  );
}

export default RefundThankyouPage;
